<template>
    <Modal id="modal-urgent-alert" @close="dismiss">
        <template #body>
            <div class="urgent-alert">
                <div class="urgent-alert-header">
                    <span class="material-icons-round urgent-alert-icon">error</span>
                    <h2 class="urgent-alert-title">Urgent Alert</h2>
                </div>
                <div class="urgent-alert-body" v-html="content"></div>
                <Button
                    label="Dismiss"
                    class="clarity-btn clarity-gradient-white urgent-alert-dismiss"
                    @click="dismiss"
                />
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from '@/components/common/Modal';
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
    name: 'UrgentAlertModal',
    components: {
        Modal,
    },
    setup() {
        const store = useStore();
        const content = computed(() => store.getters.urgentAlertContent);

        const dismiss = () => {
            // Only closes the popup for now - the alert stays available via the
            // notifications bell (see hasUrgentAlert getter) for the rest of the session.
            store.dispatch('setActiveModal');
        };

        return {
            content,
            dismiss,
        };
    },
};
</script>

<style scoped>
#modal-urgent-alert {
    /* needs to sit above all other elements, including nav */
    z-index: 3104;
}

#modal-urgent-alert:deep(.modal-close) {
    display: none !important;
}

#modal-urgent-alert:deep(.modal-body) {
    width: min(800px, 92vw);
    /* #efb7b9 / #f7dadb = --clarity-red (#d13138) mixed 35% / 18% into white */
    background: transparent linear-gradient(180deg, #efb7b9 0%, #f7dadb 100%) 0% 0% no-repeat padding-box;
    border-radius: 20px;
}

.urgent-alert {
    padding: 40px;
}

.urgent-alert-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.urgent-alert-icon {
    color: var(--clarity-red);
    font-size: 28px;
    margin-right: 12px;
}

.urgent-alert-title {
    margin: 0;
    color: var(--clarity-red);
    text-transform: uppercase;
    letter-spacing: 1px;
}

.urgent-alert-body {
    color: var(--clarity-dark-grey);
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 30px;
}

.urgent-alert-body :deep(strong),
.urgent-alert-body :deep(b) {
    color: var(--clarity-red);
}

.urgent-alert-dismiss {
    color: var(--clarity-dark-grey);
}
</style>
